<template>
    <div class="mt-5 form-material">
        <h3>Árboles</h3>
        <div class="row">
            <div class="col-md-4">
                <div class="form-group">
                    <label for="Objective">Objetivo</label>
                    <input type="number" class="form-control" id="Objective" v-model="Objective">
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <label for="PlantedTrees">Árboles Plantados</label>
                    <input type="number" class="form-control" id="PlantedTrees" v-model="PlantedTrees">
                </div>
            </div>
        </div>
        <div class="col-md-4 d-flex align-items-end">
            <button type="button" class="btn btn-primary btn-sm" @click="updateTrees" style="width: auto; padding: 0.375rem 0.75rem;">
                Actualizar
            </button>
        </div>
    </div>
  </template>
  
  <script>
  const api = window.api;
  
  export default {
    name: "TreesSet",
    data() {
      return {
        Objective: 0,
        PlantedTrees: 0,
      };
    },
    async mounted() {
        const res = await api.get("/api/trees/");
        if (res) {
            if (res.Objective) this.Objective = res.Objective;
            if (res.PlantedTrees) this.PlantedTrees = res.PlantedTrees;
        }
    },
    methods: {
        async updateTrees() {
            let res = await api.post("/api/trees/", JSON.stringify({Objective: this.Objective, PlantedTrees: this.PlantedTrees}), {'Content-Type': 'application/json' },
             (err) => { 
                this.$root.$refs.index.showNotification(err, 'danger')
             });
            if (res) {
            alert("Árboles actualizados");
            }
        },
    },
  };
  </script>
  
